<template>
    <div>
        <v-card>
            <v-row class="d-flex justify-center">
                <v-card-title class="text-h5 primary--text">Resultado da Consulta</v-card-title>
            </v-row>
            <v-row class="justify-end">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mr-2 mb-3" v-bind="attrs" v-on="on" color="primary"
                            @click="$emit('exportaBureauSCR', 1)" data-cy="exportarCSV">
                            <v-icon>
                                ph-file-csv
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>Exportar CSV</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mr-2 mb-3" depressed v-bind="attrs" v-on="on" color="primary"
                            @click="$emit('exportaBureauSCR', 2)" data-cy="exportarExcel">
                            <v-icon>ph-microsoft-excel-logo</v-icon>
                        </v-btn>
                    </template>
                    <span>Exportar EXCEL</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn label="teste" class="mr-3 mb-3" v-bind="attrs" v-on="on" depressed color="primary"
                            @click="$emit('exportaBureauSCR', 3)" data-cy="exportarPDF">
                            <v-icon>ph-file-pdf</v-icon>
                        </v-btn>
                    </template>
                    <span>Exportar PDF</span>
                </v-tooltip>

            </v-row>
            <v-card-text>
                <span class="text-h5 ml-3 primary--text">Dados do Cliente</span>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> CNPJ Solicitante </v-row>
                        <v-row class="text-subtitle"> {{ value.CnpjDaIfSolicitante }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Cliente </v-row>
                        <v-row class="text-subtitle"> {{
                                $api.UI.Format.DocumentoFederal(value.ResumoDoCliente.CodigoDoCliente)
                        }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Tipo Cliente </v-row>
                        <v-row class="text-subtitle"> {{ value.ResumoDoCliente.TipoDoCliente == 1 ? "Pessoa Física" :
                                "Pessoa Jurídica"
                        }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Dt. Início Relac </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Date(value.ResumoDoClienteTraduzido.DtInicioRelacionamento) }}
                        </v-row>
                    </v-col>
                </v-row>

                <span class="text-h5 ml-3 primary--text">Dados da Operação </span>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Coobrigação Assumida </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoCliente.CoobrigacaoAssumida) }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Coobrigação Recebida </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoCliente.CoobrigacaoRecebida) }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> % Doctos Processados </v-row>
                        <v-row class="text-subtitle">
                            {{ value.ResumoDoClienteTraduzido.PercDocumentosProcessados }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> % Volume Processado </v-row>
                        <v-row class="text-subtitle"> {{ value.ResumoDoCliente.PercentualVolumeProcessado }}
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <span class="text-subtitle"> Qtde Operações Discordância </span>
                        <v-row class="text-subtitle"> {{ value.ResumoDoCliente.QuantidadeOperacoesDiscordancia }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Vlr Operações Discordância </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.VlrOperacoesDiscordancia) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Qtde Operações Sub Judice </v-row>
                        <v-row class="text-subtitle"> {{ value.ResumoDoCliente.QuantidadeOperacoesSubJudice }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Vlr Operações Sub Judice </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.VlrOperacoesSobJudice) }}
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <span class="text-subtitle"> Qtde Instituições </span>
                        <v-row class="text-subtitle"> {{ value.ResumoDoCliente.QuantidadeDeInstituicoes }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Vlr Operações </v-row>
                        <v-row class="text-subtitle"> {{ value.ResumoDoClienteTraduzido.QtdeOperacoes }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Risco Indireto Vendor </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoCliente.RiscoIndiretoVendor) }} </v-row>
                    </v-col>
                </v-row>

                <span class="text-h5 ml-3 primary--text"> Carteira a Vencer </span>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 14 a 30 dias </v-row>
                        <v-row class="text-subtitle">
                            {{
                                    $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencerAte30diasVencidosAte14dias)
                            }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 31 a 60 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencer31a60dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 61 a 90 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencer61a90dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 91 a 180 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencer91a180dias) }}
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 181 a 360 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencer181a360dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Mais de 360 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencerAcima360dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Prazo Indeterminado </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencerPrazoIndeterminado)
                            }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Total </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencer) }} </v-row>
                    </v-col>
                </v-row>

                <span class="text-h5 ml-3 primary--text"> Vencidos </span>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 15 a 30 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencido15a30dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 31 a 60 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencido31a60dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 61 a 90 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencido61a90dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 91 a 180 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencido91a180dias) }}
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 181 a 360 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencido181a360dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Mais de 360 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencidoAcima360dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Total </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiraVencido) }} </v-row>
                    </v-col>
                </v-row>

                <span class="text-h5 ml-3 primary--text"> Prejuízo </span>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Até 12 meses </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.PrejuizoAte12meses) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Acima de 12 meses </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.PrejuizoAcima12meses) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Total </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.Prejuizo) }} </v-row>
                    </v-col>
                </v-row>

                <span class="text-h5 ml-3 primary--text"> Limite de Crédito </span>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Até 365 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.LimitesdeCreditoAte360dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Acima de 365 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.LimitesdeCreditoAcima360dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Total </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.LimitesdeCredito) }}
                        </v-row>
                    </v-col>
                </v-row>

                <span class="text-h5 ml-3 primary--text"> Outros Valores </span>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Carteira de Crédito </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CarteiradeCredito) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Repasses </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.Repasses) }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Coobrigação </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.Coobrigacoes) }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Responsabilidade Total </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.ResponsabilidadeTotal) }}
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Créditos a Liberar </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.CreditosaLiberar) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Riscos Indireto Vendor </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.RiscoIndiretoVendor) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Risco Total </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.RiscoTotal) }} </v-row>
                    </v-col>
                </v-row>

                <span class="text-h5 ml-3 primary--text"> Valores Discriminados em Moeda Estrangeira </span>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 15 a 30 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.MoedaEstrangeiraValor15a30dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 31 a 60 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.MoedaEstrangeiraValor31a60dias) }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 61 a 90 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.MoedaEstrangeiraValor61a90dias) }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 91 a 180 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.MoedaEstrangeiraValor91a180dias) }}
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> De 181 a 360 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.MoedaEstrangeiraValor181a360dias) }}
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Acima de 360 dias </v-row>
                        <v-row class="text-subtitle">
                            {{ $api.UI.Format.Currency(value.ResumoDoClienteTraduzido.MoedaEstrangeiraValorAcima360dias) }}
                        </v-row>
                    </v-col>
                </v-row>

                <span class="text-h5 ml-3 primary--text"> Modalidades </span>
                <v-divider></v-divider>
                <v-row>
                    <strong>
                        <v-checkbox label="Mostrar somente com valores" class="ml-3"
                            v-model="habilitaModalidade"></v-checkbox>
                    </strong>
                </v-row>
                <v-row>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th width="10%" class="text-left">
                                    Tipo
                                </th>
                                <th width="10%" class="text-left">
                                    Modalidade
                                </th>
                                <th width="25%" class="text-left">
                                    Dominio
                                </th>
                                <th class="text-left">
                                    Subdominio
                                </th>
                                <th width="20%" class="text-right">
                                    Valor Vencimento
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="p in listaModalidades" :key="p.listaModalidades">
                                <td>{{ p.tipo }}</td>
                                <td>{{ p.modalidade }}</td>
                                <td>{{ p.dominio }}</td>
                                <td>{{ p.subdominio }}</td>
                                <td class="text-right">{{ $api.UI.Format.Currency(p.valorVencimento) }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
  props: {
    value: {}
  },
  data () {
    return {
      habilitaModalidade: true,
      model: {
        ResumoDoCliente: {},
        ResumoDoClienteTraduzido: {},
        ResumoModalidade: [],
      },
      valueObject: {}
    }
  },
  mounted () {
    this.valueObject = this.value
  },
  computed: {
    listaModalidades () {
      const th = this
      if (th.habilitaModalidade) {
        return th.value.ResumoModalidade.filter(p => p.valorVencimento > 0)
      } else {
        return th.value.ResumoModalidade
      }
    }
  }
}
</script>
